import { useState, useEffect } from 'react';

// "Updated just now / 2 min ago" + a manual refresh, for pages backed by
// useSwrQuery (see ../swrCache.js).
//
// This is not decoration. Once a page can show cached rows, the user has no way
// to tell whether the numbers in front of them are current — and on financial
// records that's the main hazard of caching at all. This makes the age visible
// and gives anyone who needs certainty a way to force a fetch.
export default function DataFreshness({ fetchedAt, loading, onRefresh, style }) {
  // Re-render on a timer so the label actually climbs; the page itself has no
  // reason to re-render while the user is just reading it.
  const [, tick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), 10_000);
    return () => clearInterval(id);
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, fontWeight: 700, color: '#a096a8', ...style }}>
      <span>{loading ? 'Refreshing…' : `Updated ${ago(fetchedAt)}`}</span>
      <button
        type="button"
        onClick={onRefresh}
        disabled={loading}
        title="Refresh now"
        style={{
          border: 0,
          background: '#FAF8FC',
          boxShadow: 'inset 2px 2px 5px #e4dced, inset -2px -2px 5px #ffffff',
          borderRadius: 999,
          padding: '5px 11px',
          font: 'inherit',
          fontSize: 12,
          fontWeight: 800,
          color: '#6c6376',
          cursor: loading ? 'default' : 'pointer',
          opacity: loading ? 0.55 : 1,
        }}
      >
        ↻ Refresh
      </button>
    </div>
  );
}

function ago(fetchedAt) {
  if (!fetchedAt) return 'never';
  const secs = Math.max(0, Math.round((Date.now() - fetchedAt) / 1000));
  if (secs < 15) return 'just now';
  if (secs < 60) return `${secs} sec ago`;
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.round(mins / 60);
  return `${hrs} hr ago`;
}
